import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import {useTranslation} from 'react-i18next';


const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    container: {

        fontSize: 16,
        display: 'flex',
        alignItems: 'flex-start',
       
        flexDirection: 'row',
        marginTop: '0px',
        marginLeft: '40px',
        marginRight: '40px',
        marginBootom: '10px',
        
      
        flexGrow: 1,
       
    },
    itemName: {
        width: '35%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    catalog: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    qty: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    um: {
        width: '5%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    priceOnePcs: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    vat: {
        width: '5%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    priceExcludeVat: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    priceIncludeVat: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
   
  });

  const InvoiceTableHeader = () => {
      
    const [t] = useTranslation();     
    const {i18n} = useTranslation();

    return (
        <View style={styles.container}>
            <Text style={styles.itemName}>{t('article.label.articleName')}</Text>
            <Text style={styles.catalog}>{t('article.label.catalog')}</Text>
            <Text style={styles.qty}>{t('document.label.qty')}</Text>
            <Text style={styles.um}>{t('document.label.um')}</Text>
            <Text style={styles.priceOnePcs}>{t('article.label.priceOnePcs')}</Text>
            <Text style={styles.vat}>{t('article.label.vat')}</Text>
            <Text style={styles.priceExcludeVat}>{t('document.label.priceExcludeVat')}</Text>
            <Text style={styles.priceIncludeVat}>{t('document.label.priceIncludeVat')}</Text>
        </View>
  )
};
  
  export default InvoiceTableHeader